import type { FC } from "react";
import type { VenueEventListViewModel } from "src/http/types";
import { LazyFooter } from "src/website-apps/shared/components/footer";

interface Props {
  model: VenueEventListViewModel;
}

export const VenueLayoutV2Footer: FC<Props> = ({ model }) => (
  <LazyFooter
    companyLinks={model.footer.companyLinks}
    supportLinks={model.footer.supportLinks}
    getLocationSettingsUrl={model.footer.getLocationSettingsUrl}
  />
);
